import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthModal from "@/components/feature/AuthModal";

const navLinks = [
  { label: "Jobs", href: "#jobs" },
  { label: "Ads", href: "#ads" },
  { label: "Global Factory", href: "#global-factory" },
  { label: "Buyer Requests", href: "#buyer-requests" },
  { label: "Marketplace", href: "#marketplace" },
  { label: "News & Lottery", href: "#news" },
  { label: "Dropshipping", href: "#dropshipping" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [authOpen, setAuthOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <a href="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/3fc89005e5f8f541d0781d07714068dd/20f82aeec2f5e698a996684cc4a84b3a.jpeg"
            alt="CrownBoostAdsJob Logo"
            className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover"
          />
          <div className="hidden sm:block">
            <span className={`font-bold text-base md:text-lg leading-tight block ${scrolled ? "text-gray-900" : "text-white"}`}>
              CrownBoost
            </span>
            <span className={`text-xs leading-tight block ${scrolled ? "text-amber-600" : "text-amber-300"}`}>
              AdsJob Portal
            </span>
          </div>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-6">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? "text-gray-700 hover:text-amber-600" : "text-white/90 hover:text-white"
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* CTA Buttons */}
        <div className="hidden md:flex items-center gap-3">
          <button
            onClick={() => setAuthOpen(true)}
            className={`text-sm font-medium px-4 py-2 rounded-md border transition-colors cursor-pointer whitespace-nowrap ${
              scrolled ? "border-gray-300 text-gray-700 hover:border-amber-500 hover:text-amber-600" : "border-white/50 text-white hover:border-white"
            }`}
          >
            <i className="ri-user-line mr-1.5"></i>Sign In / Sign Up
          </button>
          <button
            onClick={() => navigate("/membership")}
            className="text-sm font-semibold px-4 py-2 rounded-md bg-amber-500 hover:bg-amber-600 text-white transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5"
          >
            <i className="ri-vip-crown-fill text-xs"></i>
            Membership
          </button>
        </div>

        {/* Mobile Hamburger */}
        <button
          className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${scrolled ? "text-gray-800" : "text-white"}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {/* Auth Modal */}
      <AuthModal isOpen={authOpen} onClose={() => setAuthOpen(false)} />

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-4 py-4 flex flex-col gap-3">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-sm font-medium text-gray-700 hover:text-amber-600 cursor-pointer py-1"
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <div className="flex gap-3 pt-2 border-t border-gray-100">
            <button
              onClick={() => { setAuthOpen(true); setMenuOpen(false); }}
              className="flex-1 text-sm font-medium px-4 py-2 rounded-md border border-gray-300 text-gray-700 cursor-pointer whitespace-nowrap"
            >
              Sign In / Sign Up
            </button>
            <button
              onClick={() => { navigate("/membership"); setMenuOpen(false); }}
              className="flex-1 text-sm font-semibold px-4 py-2 rounded-md bg-amber-500 text-white cursor-pointer whitespace-nowrap flex items-center justify-center gap-1"
            >
              <i className="ri-vip-crown-fill text-xs"></i>Membership
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
